import { render, staticRenderFns } from "./TwoStepVerification.vue?vue&type=template&id=0b4af516&scoped=true&"
import script from "./TwoStepVerification.vue?vue&type=script&lang=js&"
export * from "./TwoStepVerification.vue?vue&type=script&lang=js&"
import style0 from "./TwoStepVerification.vue?vue&type=style&index=0&id=0b4af516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4af516",
  null
  
)

export default component.exports